import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    pageWrapper: {
        paddingTop: "10%",
        width: "80%",
        marginRight: "auto",
        marginLeft: "auto"
    },
    flexComponent: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        flexDirection: "row"
    },
    smallBox: {
        borderColor: "black",
        width: "49.5%",
        padding: "2px"
    },
    largeBox: {
        borderWidth: 1,
        borderColor: "black",
        width: "100%",
        padding: "2px",
        marginTop: "2px"
    },
    smallText: {
        fontSize: 9,
        paddingLeft: "10px",
        paddingRight: "10px",
        marginTop: "4px",
        marginBottom: "4px"
    },
    informationFieldWrapper: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap"
    },
    label: {
        fontFamily: "Times-Bold",
    },
    headerOne: {
        fontFamily: "Times-Bold",
        fontSize: 16,
    },
    headerTwo: {
        fontFamily: "Times-Bold",
        fontSize: 11,
    },
    table: {
        margin: "10px",
        display: "flex",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableCol: {
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderTopWidth: 0
    },
    tableColLarge: {
        width: "46%",
    },
    tableColSmall: {
        width: "18%",
    },
    tableCell: {
        padding: "2px",
        marginTop: 5,
        fontSize: 9
    },
    alignCenter: {
        textAlign:"center"
    },
    alignRight: {
        textAlign: "right"
    }
})